import GeoPointEditor from "./GeoPointEditor.js";
import GeoPointModel from "./GeoPointModel.js";
import GeoPointRenderer from "./GeoPointRenderer.js";
import GeoShapeEditor from "./GeoShapeEditor.js";
import GeoShapeModel from "./GeoShapeModel.js";
import GeoShapeRenderer from "./GeoShapeRenderer.js";
import GeohashGridDataLayer from "./GeohashGridDataLayer.js";
import GeohashGridEditor from "./GeohashGridEditor.js";
import GeohashGridModel from "./GeohashGridModel.js";
import GroupClusterDataLayer from "./GroupClusterDataLayer.js";
import GroupClusterEditor from "./GroupClusterEditor.js";
import GroupClusterModel from "./GroupClusterModel.js";
import HeatmapEditor from "./HeatmapEditor.js";
import HeatmapModel from "./HeatmapModel.js";
import UserPositionEditor from "./UserPositionEditor.js";
import UserPositionModel from "./UserPositionModel.js";
import UserPositionRendererPlg from "./UserPositionRendererPlg.js";
export default {
  install(molten) {
    molten.addPlugin('Model', {
      type: GeoPointModel.TYPE,
      model: GeoPointModel
    });
    molten.addPlugin('ModelEditor', {
      type: GeoPointModel.TYPE,
      editor: GeoPointEditor
    });
    molten.addPlugin('GoogleMapsLayerRenderer', {
      type: GeoPointModel.TYPE,
      layerRenderer: GeoPointRenderer
    });
    molten.addPlugin('Model', {
      type: GeoShapeModel.TYPE,
      model: GeoShapeModel
    });
    molten.addPlugin('ModelEditor', {
      type: GeoShapeModel.TYPE,
      editor: GeoShapeEditor
    });
    molten.addPlugin('GoogleMapsLayerRenderer', {
      type: GeoShapeModel.TYPE,
      layerRenderer: GeoShapeRenderer
    });
    molten.addPlugin('Model', {
      type: GeohashGridModel.TYPE,
      model: GeohashGridModel
    });
    molten.addPlugin('ModelEditor', {
      type: GeohashGridModel.TYPE,
      editor: GeohashGridEditor
    });
    molten.addPlugin('GoogleMapsLayerRenderer', {
      type: GeohashGridModel.TYPE,
      layerRenderer: GeohashGridDataLayer
    });
    molten.addPlugin('Model', {
      type: GroupClusterModel.TYPE,
      model: GroupClusterModel
    });
    molten.addPlugin('ModelEditor', {
      type: GroupClusterModel.TYPE,
      editor: GroupClusterEditor
    });
    molten.addPlugin('GoogleMapsLayerRenderer', {
      type: GroupClusterModel.TYPE,
      layerRenderer: GroupClusterDataLayer
    });
    molten.addPlugin('Model', {
      type: UserPositionModel.TYPE,
      model: UserPositionModel
    });
    molten.addPlugin('ModelEditor', {
      type: UserPositionModel.TYPE,
      editor: UserPositionEditor
    });
    molten.addPlugin('Model', {
      type: HeatmapModel.TYPE,
      model: HeatmapModel
    });
    molten.addPlugin('ModelEditor', {
      type: HeatmapModel.TYPE,
      editor: HeatmapEditor
    });
    molten.addPlugin('GoogleMapsRenderer', UserPositionRendererPlg);
  }
};